import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "@phosphor-icons/react";

const STORAGE_KEY = "lawfields_cookie_consent_v1";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) setVisible(true);
      } catch {
        setVisible(true);
      }
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, at: new Date().toISOString() })
      );
    } catch {
      // ignore — banner still dismisses
    }
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          data-testid="cookie-banner"
          className="fixed bottom-4 left-4 right-4 md:left-8 md:right-8 lg:bottom-6 lg:right-6 lg:left-auto lg:max-w-md z-[9998]"
        >
          <div className="relative border border-[#E9C76A]/30 bg-[#14141A]/95 backdrop-blur-xl p-6 md:p-7 shadow-2xl glass-card">
            <button
              data-testid="cookie-close"
              onClick={() => decide("dismissed")}
              aria-label="Close cookie notice"
              className="absolute top-3 right-3 text-white/40 hover:text-[#E9C76A] transition-colors"
            >
              <X size={18} weight="thin" />
            </button>
            <div className="flex items-start gap-4">
              <Cookie
                size={24}
                weight="thin"
                className="text-[#E9C76A] flex-shrink-0 mt-1"
              />
              <div className="flex-1 pr-4">
                <div className="overline mb-2">Your privacy</div>
                <p className="text-sm text-white/70 font-light leading-relaxed">
                  We use only essential cookies to make this site work. We do not track
                  you for advertising. See our{" "}
                  <a
                    href="/privacy"
                    className="text-[#E9C76A] underline underline-offset-4 hover:text-[#C5A028]"
                  >
                    Privacy Policy
                  </a>
                  .
                </p>
              </div>
            </div>
            <div className="mt-5 flex flex-wrap gap-3">
              <button
                data-testid="cookie-accept"
                onClick={() => decide("accepted")}
                className="btn-gold !px-5 !py-3"
              >
                Accept
              </button>
              <button
                data-testid="cookie-reject"
                onClick={() => decide("essential_only")}
                className="border border-white/20 text-white/75 font-sans font-medium text-[11px] tracking-[0.18em] uppercase px-5 py-3 hover:border-[#E9C76A] hover:text-[#E9C76A] transition-colors"
              >
                Essential Only
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
